import { render, staticRenderFns } from "./Talant.vue?vue&type=template&id=021a3099&scoped=true&"
import script from "./Talant.vue?vue&type=script&lang=js&"
export * from "./Talant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a3099",
  null
  
)

export default component.exports